export default __webpack_public_path__ + "static/media/DSC_0731.9e4d516f.JPG";